// Global referral address storage
// Can be accessed from any page and only overwrites with new non-empty addresses

let globalReferralAddress = null;

/**
 * Get the current global referral address
 * @returns {string|null} The referral address or null if not set
 */
export const getReferralAddress = () => {
    return globalReferralAddress;
};

/**
 * Set the referral address
 * Only overwrites if the new address is not empty/null/undefined
 * @param {string|null|undefined} newAddress - The new referral address to set
 * @returns {boolean} True if the address was set, false if it was rejected
 */
export const setReferralAddress = (newAddress) => {
    // Only set if newAddress is a non-empty string
    if (newAddress && typeof newAddress === 'string' && newAddress.trim() !== '') {
        globalReferralAddress = newAddress.trim();
        return true;
    }
    // If trying to set empty/null/undefined, don't overwrite existing value
    return false;
};

/**
 * Clear the referral address (only if explicitly needed)
 * @returns {void}
 */
export const clearReferralAddress = () => {
    globalReferralAddress = null;
};

/**
 * Check if a referral address is currently stored
 * @returns {boolean} True if a referral address exists
 */
export const hasReferralAddress = () => {
    return globalReferralAddress !== null && globalReferralAddress !== '';
};

